import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { NumericFormat } from 'react-number-format';
import { SvgIcon, Tooltip } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import AffordableIcon from '../../../../icons/affordable.svg?react';
import FastIcon from '../../../../icons/fast.svg?react';
import './QuoterFiltersCondensed.scss';

export default function QuoterSort(props) {
    const [filterState, setFilterState] = useState(props.filterObject || {
        noMedicalExamOnly: false,
        digitalOnly: false,
        phoneOnly: false,
        convertibleOnly: false,
        levelTerm: true,
        decreasingTerm: true,
    });
    const handleToolTip = (e) => {
        e.stopPropagation();
    }
    useEffect(() => {
        if (props.setFilterObject) props.setFilterObject(filterState);
    }, [filterState]);

    return (
        <React.Fragment>
            <div className="filter-control-wrapper">
                <div className="sort-container">
                    <h4>Sort By</h4>
                    <Row className='align-items-center pt-2 mx-0'>
                        <Col xs={12} md={7} className={`px-0 term-quote-sort-rounded`}>
                            <Row className="term-quote-sort-track px-3">
                                <Col xs={6} className={`term-sort-option left-radius pe-2 borderOutline ${props.isSortedByPrice ? "lightBG background-color-16" : 'disabled-class'}`} onClick={() => props.setSortedByPrice(true)}>
                                    <div className="icon-container mb-0">
                                        <SvgIcon component={AffordableIcon} color={!props.isSortedByPrice ? 'disabled' : 'primary'} />
                                    </div>
                                    <div className="content-container">
                                        <p className={`title ${props.isSortedByPrice ? "primary-color" : 'disabled-class'}`}>Lowest Price</p>
                                        <p className="cost mb-1">{props.lowestPrice ? <NumericFormat value={props.lowestPrice} displayType={'text'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={'$'} /> : "--"}/mo</p>
                                    </div>
                                    <div className="help-container" onClick={handleToolTip}>
                                        <Tooltip title="Companies and products offering the best pricing based on your inputs."
                                            enterTouchDelay={0}
                                            slotProps={{
                                                tooltip: {
                                                    className: 'light-tooltip',
                                                    sx: { fontSize: '11px' }
                                                },
                                            }}
                                        >
                                            <InfoOutlinedIcon className='help-tooltip' />
                                        </Tooltip>
                                    </div>
                                </Col>
                                <Col xs={6} className={`term-sort-option right-radius ps-2 borderOutline ${!props.isSortedByPrice ? "lightBG background-color-16" : 'disabled-class'}`} onClick={() => props.setSortedByPrice(false)}>
                                    <div className="icon-container mb-0">
                                        <SvgIcon component={FastIcon} color={props.isSortedByPrice ? 'disabled' : 'primary'} />
                                    </div>
                                    <div className="content-container">
                                        <p className={`title ${!props.isSortedByPrice ? "primary-color" : 'disabled-class'}`}>Fastest Approval</p>
                                        <p className="cost mb-1">{props.fastestRate ? <NumericFormat value={props.fastestRate} displayType={'text'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={'$'} /> : "--"}/mo</p>
                                    </div>
                                    <div className="help-container" onClick={handleToolTip}>
                                        <Tooltip
                                            title="Companies whose digital underwriting will get you coverage quickly and possibly without a medical exam." enterTouchDelay={0}
                                            slotProps={{
                                                tooltip: {
                                                    className: 'light-tooltip',
                                                    sx: { fontSize: '11px' }
                                                },
                                            }}
                                        >
                                            <InfoOutlinedIcon className='help-tooltip' />
                                        </Tooltip>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}
